<template>
  <div class="footer">Copyright©{{ year }}途陽国際株式会社所有权利</div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: #14141e;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 48px 0;
  box-sizing: border-box;
  text-align: center;
  @media (max-width: $mobile-breakpoint) {
    font-size: 14px;
  }
}
</style>
